// extracted by mini-css-extract-plugin
module.exports = {"actionsRow":"genericList_actionsRow__tAFBf","center":"genericList_center__Ihajs"};